import { get } from "api/apiBridges/httpBridge";
import { redirect } from "react-router-dom";
import { loginSelector } from "store/slices/loginSlice";
import store from "store/store"; // Импортируем store

export async function dealAuthLoader({ request, params }) {
    const { dealId } = params;

    const url = new URL(request.url);

    // Получаем состояние напрямую из store
    const state = store.getState();
    const { token, isSuccess, rules, role } = loginSelector(state);

    // Базовая проверка авторизации
    if ((!token || token === '') && !isSuccess) {
        return redirect(`/login?redirect=${encodeURIComponent(url.pathname)}`);
    }

    //TODO сделать переход на клиентскую версию и наоборот
    if (role !== 'admin') {return redirect('/home');}
    
    // Проверка доступа к конкретной сделке
    if (dealId) {
        try {
            const dealData = await get('Deal/getType', { did: dealId });
            
            if (!dealData.message) {
                return redirect('/home'); // Сделка не найдена
            }

            if (rules.includes("admin")) {
                return null
            }

            switch (dealData.message) {
                case "pik_goods":
                    if (rules.includes("main.pick_product")) 
                        {
                            // localStorage.setItem('TAB', "pickProducts");//Тут надо будет подумать как сделать правильно перемещение между вкладками при получении ссылки на сделку
                            return null
                        }
                    else return redirect('/home');
                case "moving_deals":
                    if (rules.includes("main.move_product")) return null
                    else return redirect('/home');
                case "products_storage":
                    if (rules.includes("main.storage_product")) return null
                    else return redirect('/home');
                case "products_shipment":
                    if (rules.includes("main.shipment_product")) return null
                    else return redirect('/home');
            }
            
            return null; // Доступ разрешен
        } catch (error) {
            console.error('Ошибка проверки доступа к сделке:', error);
            return redirect('/home');
        }
    }
    
    return null;
}


export async function clientDealAuthLoader({ request, params }) {
    const { dealId } = params;

    const url = new URL(request.url);

    // Получаем состояние напрямую из store
    const state = store.getState();
    const { token, isSuccess, rules, role } = loginSelector(state);

    // Базовая проверка авторизации
    if ((!token || token === '') && !isSuccess) {
        return redirect(`/login?redirect=${encodeURIComponent(url.pathname)}`);
    }

    //TODO сделать переход на клиентскую версию и наоборот
    if (role !== 'client') {return redirect('/home');}
    
    // Проверка доступа к конкретной сделке
    if (dealId) {
        try {
            const dealData = await get('Deal/getType', { did: dealId });
            
            if (!dealData.message) {
                return redirect('/home'); // Сделка не найдена
            }

            return null 

            //TODO прописать права по аналогии

        } catch (error) {
            console.error('Ошибка проверки доступа к сделке:', error);
            return redirect('/home');
        }
    }
    
    return null;
}
